"use client";

import { WITHDRAWAL_BUTTON_LABEL, gruvContactFormUrl } from "@/lib/contactForm";

export type WithdrawalButtonProps = {
  className?: string;
};

/**
 * Public BOTÓN DE ARREPENTIMIENTO. Opens the existing claims/refund Google Form
 * without requiring a GRUV login. Intake only — no automatic refund.
 */
export function WithdrawalButton({ className }: WithdrawalButtonProps) {
  const href = gruvContactFormUrl();
  const classes = ["gruv-withdrawal-button", className ?? ""].filter(Boolean).join(" ");

  return (
    <a
      className={classes}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="withdrawal-button"
    >
      {WITHDRAWAL_BUTTON_LABEL}
    </a>
  );
}
